import clsx from 'clsx';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

export type SelectProps = {
  label?: string;
  options: SelectOption[];
  className?: string;
  placeholder?: string;
  selectClassName?: string;
} & React.SelectHTMLAttributes<HTMLSelectElement>;

export type SelectOption = {
  label: string;
  value: string;
};

export function Select({
  label,
  name,
  className,
  options,
  required,
  placeholder,
  selectClassName,
  ...rest
}: SelectProps) {
  const selectElement = (
    <div className={clsx('relative', !label && className)}>
      <select
        name={name}
        className={clsx('w-full appearance-none rounded-md px-4 py-[14px] pr-10', selectClassName)}
        required={required}
        {...rest}
      >
        {/* TODO: work out if we can style the placeholder */}
        <option value="" className="">
          {placeholder}
        </option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <ChevronDownIcon className="pointer-events-none absolute right-3 top-1/2 size-5 -translate-y-1/2" />
    </div>
  );

  if (!label) {
    return selectElement;
  }

  return (
    <label className={clsx('flex w-full flex-col gap-3', className)}>
      {label} {required && '*'}
      {selectElement}
    </label>
  );
}
